var path = '/home/jenkins/workspace/arcade_Arcade-UI_release/app/views/states/help.html';
var html = "<div track-feature=\"$track.features.help\" id=\"help-page\">\n  <contact-us></contact-us>\n\n  <section class=\"padded grey\">\n    <faq></faq>\n  </section>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
export default  path;